import React, { Fragment } from "react";
import MaterialTable from "material-table";
import { authCheckState } from "../../../store/actions/auth";
import { mainLink } from "../../../store/utils";
import axios from "axios";
import Loading from "../../../components/Loading/index";

import { MTableToolbar } from "material-table";
import { connect } from "react-redux";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import {
  postBookEdition,
  getBookEdition,
  deleteBookEdition,
  editBookEdition,
} from "../../../store/actions/book";
import { compose } from "redux";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Redirect } from "react-router";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = (theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "20ch",
    },
  },
});

class Component extends React.Component {
  state = {
    data: [],
    formDisplay: false,
    loading: false,
    redirect: false,
    redirectLink: "",
  };
  componentDidMount() {
    this.props.authCheckState();
    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${this.props.token}`,
    };
    this.setState({ loading: true });
    axios
      .get(mainLink + "/api/v1/trainer/")
      .then((res) => {
        this.setState({ loading: false });

        this.setState({
          data: res.data,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });

        this.setState({ isErrorDialogPopUp: true, ErrorMessage: err.message });
      });
  }
  setRedirect = (link) => {
    // eslint-disable-next-line react/no-direct-mutation-state
    this.state.redirectLink = link;
    this.setState({
      redirectLink: this.state.redirectLink,
      redirect: true,
    });
  };
  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirectLink} />;
    }
  };

  render() {
    const handleErrorClose = () => {
      this.setState({ isErrorDialogPopUp: false });
    };
    return this.state.loading ? (
      <Fragment>
        <Loading />
      </Fragment>
    ) : (
      <Fragment>
        <Dialog
          open={this.state.isErrorDialogPopUp}
          onClose={handleErrorClose}
          TransitionComponent={Transition}
          // PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            Error Message
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <span style={{ color: "red", fontSize: "small", marginLeft: 20 }}>
                {this.state.ErrorMessage}
              </span>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleErrorClose} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        {this.renderRedirect()}
        <MaterialTable
          title={
            <span style={{ fontSize: 20, fontWeight: "bold" }}>
              प्रशिक्षकहरू
            </span>
          }
          columns={[
            {
              title: "परिचय नम्बर",
              field: "serial_number",
              emptyValue: "",
            },
            {
              title: "नाम",
              field: "name",
              emptyValue: "",
              render: (rowData) => (
                <span>
                  {rowData.name.length >= 25
                    ? `${rowData.name.substr(0, 25)}...`
                    : rowData.name}
                </span>
              ),
            },
            {
              title: "ठेगाना",
              field: "address",
              emptyValue: "",
            },
            {
              title: "ईमेल",
              field: "email",
              emptyValue: "",
            },
            {
              title: "  शैक्षिक योग्यता",
              field: "educational_qualification",
              emptyValue: "",
            },
            {
              title: "सम्बद्ध संस्था/पद",
              field: "post",
              emptyValue: "",
            },
            {
              title: "अनुभव",
              field: "experience",
              emptyValue: "",
            },
            {
              title: "प्रशिक्षक प्रकार",
              field: "trainerType",
              emptyValue: "",
            },
            {
              title: "सम्पर्क नम्बर",
              field: "phone_number",
              emptyValue: "",
            },
          ]}
          data={this.state.data}
          options={{
            filtering: false,
            actionsColumnIndex: -1,
            emptyRowsWhenPaging: false,
            pageSize: 50,
            pageSizeOptions: [50, 100, 200],
          }}
          editable={{
            onRowDelete: (oldData) =>
              new Promise((resolve, reject) => {
                const dataDelete = this.state.data;
                const index = oldData.tableData.id;
                this.setState({ loading: true });
                axios
                  .delete(mainLink + `/api/v1/trainer/${oldData.id}/`)
                  .then((res) => {
                    this.setState({ loading: false });
                    dataDelete.splice(index, 1);
                    this.setState([...dataDelete]);
                  })
                  .catch((err) => {
                    this.setState({ loading: false });

                    this.setState({
                      isErrorDialogPopUp: true,
                      ErrorMessage: err.message,
                    });
                  });

                resolve();
              }),
          }}
          actions={[
            {
              icon: "edit",
              tooltip: "Edit",
              onClick: (event, rowData) => {
                this.setRedirect(`/admin/trainer-edit/${rowData.id}`);
              },
            },
          ]}
          localization={{
            toolbar: {
              searchTooltip: "खोजी गर्नुहोस्",
              searchPlaceholder: "खोजी गर्नुहोस्",
            },
            header: {
              actions: "कार्यहरू",
            },
            body: {
              emptyDataSourceMessage: "कुनै रेकर्ड छैन",
              filterRow: {
                filterTooltip: "Filter",
              },
            },
          }}
          components={{
            Toolbar: (props) => (
              <div>
                <div style={{ padding: 20, paddingBottom: 0 }}>
                  <Link
                    label="Chip 1"
                    color="secondary"
                    style={{ marginRight: 5, float: "right" }}
                    to="/admin/trainer-create/"
                  >
                    {this.props.permissions && this.props.permissions.length ? (
                      (!this.props.permissions ||
                        this.props.permissions.indexOf("edition-add") >= 0) && (
                        <AddIcon style={{ fontSize: 40 }} />
                      )
                    ) : (
                      <AddIcon style={{ fontSize: 40 }} />
                    )}
                  </Link>
                </div>
                <MTableToolbar {...props} />
              </div>
            ),
          }}
        />
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    editions: state.book.editions,
    token: state.auth.token,
    userId: state.auth.userId,
    loading: state.book.loading,
    error: state.book.error,
    isAuthenticated: state.auth.token !== null,
    successAuth: state.auth.successAuth,
    permissions:
      typeof state.auth.user["permissions"] != "undefined"
        ? state.auth.user.permissions
        : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onPostBookEdition: (editionName, token) =>
      dispatch(postBookEdition(editionName, token)),
    onGetBookEdition: (token) => dispatch(getBookEdition(token)),
    ondeleteBookEdition: (editionId, token) =>
      dispatch(deleteBookEdition(editionId, token)),
    editBookEdition: (newEdition, editionId, token) =>
      dispatch(editBookEdition(newEdition, editionId, token)),
    authCheckState: () => dispatch(authCheckState()),
  };
};
export default compose(
  withStyles(useStyles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps)
)(Component);
